import {
    REVERSE_GST_CHARGE_REPORT_REQUEST,
    REVERSE_GST_CHARGE_REPORT_SUCCESS,
    REVERSE_GST_CHARGE_REPORT_FAILURE,
  } from "../types/reverse-gst-charge-report-types.js";
  
  const initialState = {
    reverseGstChargeReport: {},
    loading: false,
    error: null,
  };
  
  const reverseGstChargeReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case REVERSE_GST_CHARGE_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case REVERSE_GST_CHARGE_REPORT_SUCCESS: {
        return {
          ...state,
          reverseGstChargeReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case REVERSE_GST_CHARGE_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default reverseGstChargeReportReducer;
  